import { render, staticRenderFns } from "./InformatizaAps.vue?vue&type=template&id=1467d974"
import script from "./InformatizaAps.vue?vue&type=script&lang=js"
export * from "./InformatizaAps.vue?vue&type=script&lang=js"
import style0 from "./InformatizaAps.vue?vue&type=style&index=0&id=1467d974&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports